"use client";

import { useRouter } from "next/navigation";

import type { ExtendedPrimaryCTAProps } from "@/components/sign-up/primary-cta";
import { PrimaryCTA } from "@/components/sign-up/primary-cta";
import { usePWAPrompt } from "@/hooks/usePWAPrompt";
import { APP_ROUTES } from "@/utils/constants";
import { cn } from "@/utils/lib";

import { PWAInstallModal } from "./pwa-install-modal";

type SignUpProps = ExtendedPrimaryCTAProps & {
  children?: React.ReactNode;
  defaultOpen?: boolean;
  handleOpen?: (open: boolean) => void;
};

export const SignUp = ({
  innerWrapperClassName,
  className,
  secondaryLinksClassName,
  children,
  ...props
}: SignUpProps) => {
  const {
    showPWAPrompt,
    handlePWACancel,
    handlePWASkip,
    handleClick: handlePWAClick,
    showPWAPromptFirst: isPWAPromptFirst,
  } = usePWAPrompt();
  const router = useRouter();

  const handleCreateWalletClick = (e: React.MouseEvent) => {
    if (isPWAPromptFirst()) {
      handlePWAClick(e);
    }
  };

  return (
    <>
      {showPWAPrompt && (
        <PWAInstallModal
          onCancel={() => {
            handlePWACancel();
          }}
          onSkip={async () => {
            if (!(await handlePWASkip())) {
              router.push(APP_ROUTES.signUp);
            }
          }}
        />
      )}
      <PrimaryCTA
        {...props}
        tradeLinkLabel="Buy"
        secondaryLinksClassName={cn("w-full", secondaryLinksClassName)}
        primaryLinksClassName="flex items-center justify-center"
        innerWrapperClassName={innerWrapperClassName}
        className={className}
        onCreateWalletClick={handleCreateWalletClick}
      >
        {children}
      </PrimaryCTA>
    </>
  );
};
